import {AttachmentsForRenderProps} from "types/attachment";
import React from "react";

const Pdf = ({collection, url}: AttachmentsForRenderProps): React.ReactElement => {

    return <div className={"attachment-image-container h-100 py-2"}>
        <embed id={"iframe_" + collection.id}
                src={url}
                title={"iframe_for_pdf_" + collection.id}
                className="pdf-iframe-container w-100 h-100 rounded-4"/>
    </div>
}

export default Pdf;